import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export default function FatherInPropdisplay() {
    const ownerInfo = useSelector((state) => state?.addressdetail?.info1);
; 
  return (
    <>
    <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1">
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">FULL NAME</div>
        <div className="indivtext">{ownerInfo?.FatherInLaw?.title}. {' '}{ownerInfo?.FatherInLaw?.FatherInName}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">DATE OF BIRTH</div>
        <div className="indivtext">{ownerInfo?.FatherInLaw?.dateofbirth}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Height</div>
        <div className="indivtext">{ownerInfo?.FatherInLaw?.FatherInHeight}{' '}{ownerInfo?.FatherInLaw?.FatherInInches}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Weight</div>
        <div className="indivtext">{ownerInfo?.FatherInLaw?.FatherInWeight}{' '}kg</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">Blood Group</div>
        <div className="indivtext">{ownerInfo?.FatherInLaw?.FatherInBloodGroup}</div>
      </div>
    </div>
    </>
  );
}
